import { Controller } from "@hotwired/stimulus"

// Choosing an option saves it and moves on to the next question. Highlight the choice as soon as it's
// clicked and say it's saved, so it's clear the answer was taken while the next question loads.
export default class extends Controller {
  static targets = ["option", "status"]
  static values = { selectedClass: String }

  choose(event) {
    const chosen = event.currentTarget
    const selectedClasses = this.selectedClassValue.split(" ").filter(Boolean)

    this.optionTargets.forEach((option) => {
      const selected = option === chosen
      option.setAttribute("aria-pressed", selected)
      selectedClasses.forEach((name) => option.classList.toggle(name, selected))
    })

    if (this.hasStatusTarget) this.statusTarget.textContent = "Saved. On to the next question…"
  }
}
